<!--<div *ngFor="let alert of alerts" class="{{cssClass(alert)}}">-->
<!--    <a class="close" (click)="removeAlert(alert)">&times;</a>-->
<!--    <span [innerHTML]="alert.message"></span>-->
<!--</div>-->
<div *ngFor="let alert of alerts" class="flex justify-center top-0 fixed z-999 top-5 h-12 w-2/4 left-96">
    <div class=" border w-2/4 flex justify-center top-0 fixed z-999 top-5 h-12 left-96" role="alert" [ngClass]="cssClass(alert)">
        <!--        <strong class="font-bold">Holy smokes!</strong>-->
        <span class="top-3 relative">{{alert.message}}</span>
        <button
            class="fuse-alert-dismiss-button absolute top-2.5"
            mat-icon-button style="cursor: pointer;right: 16px !important;"
            (click)="removeAlert(alert)">
            <mat-icon [svgIcon]="'custom:close'"></mat-icon>
        </button>
        <!--span class="absolute top-0 bottom-0 right-0 px-4 py-3">
            <svg class="fill-current h-6 w-6" [ngClass]="cssClass(alert)" role="button"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <title>{{dashboardService.translate('Close')}}</title>
                <path
                    d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
            </svg>
        </span-->
    </div>
</div>